export const Status = {
  None: _TL_('-'),
  Created: _TL_('-'),
  ImportInProgress: _TL_('Pending'),
  Imported: _TL_('Successful'),
  ImportFailed: _TL_('Failed'),
};
